/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React from "react";
import { OidcSecure } from "@axa-fr/react-oidc";
import { Route, Routes } from "react-router-dom";
import EditTenantPage from "./components/EditTenant/EditTenantPage";
import EditHoneywellUser from "./components/HoneywellUser/EditHoneywellUser";
import CreateOrganisation from "./components/Organisation/create-organisation/CreateOrganisation";
import EditOrganisation from "./components/Organisation/edit-organisation/EditOrganisation";
import OrganizationList from "./components/Organisation/organization-list/OrganizationList";
import OrganizationUserList from "./components/Organisation/organization-user-list/OrganizationUserList";
import TenantUserPage from "./components/TenantUser/TenantUserPage";
import UserInformationPage from "./components/UserManagement/UserInformation";
import UserManagement from "./components/UserManagement/UserManagement";
import ErrorPage from "./pages/Error/ErrorPage";
import LogOut from "./pages/LogOut";
import LoggedIn from "./pages/LoggedIn/LoggedInPage";
import CreateUserPage1 from "./components/UserManagement/CreateUser1";
import EditUserPage1 from "./components/UserManagement/EditUser1";
import SetupTenantPage from "./components/SetupTenant/SetupTenantPage";
import { SettingsPage } from "./components/SetupTenant/settingPage/SettingsPage";
import { EditSettings } from "./components/EditTenant/EditSettings";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Other Routes */}
      <Route
        path="/setup"
        element={
          <OidcSecure>
            <SetupTenantPage />
          </OidcSecure>
        }
      />
      <Route
        path="/organization"
        element={
          <OidcSecure>
            <OrganizationList />
          </OidcSecure>
        }
      />
      <Route
        path="/create-organization"
        element={
          <OidcSecure>
            <CreateOrganisation />
          </OidcSecure>
        }
      />
      <Route
        path="/organization-user-list"
        element={
          <OidcSecure>
            <OrganizationUserList />
          </OidcSecure>
        }
      />
      <Route
        path="/organization/edit"
        element={
          <OidcSecure>
            <EditOrganisation />
          </OidcSecure>
        }
      />
      <Route
        path="/:role/user/create"
        element={
          <OidcSecure>
            <CreateUserPage1 />
          </OidcSecure>
        }
      />
      <Route
        path="/organization/user/create"
        element={
          <OidcSecure>
            <CreateUserPage1 />
          </OidcSecure>
        }
      />
      <Route
        path="/tenant/edit/:id"
        element={
          <OidcSecure>
            <EditTenantPage />
          </OidcSecure>
        }
      />
      <Route
        path="/:role/edit/:id"
        element={
          <OidcSecure>
            <EditTenantPage />
          </OidcSecure>
        }
      />
      <Route
        path="/tenant/user"
        element={
          <OidcSecure>
            <TenantUserPage />
          </OidcSecure>
        }
      />
      <Route
        path="/:role/user/edit"
        element={
          <OidcSecure>
            <EditUserPage1 />
          </OidcSecure>
        }
      />
      <Route
        path="/user"
        element={
          <OidcSecure>
            <UserManagement />
          </OidcSecure>
        }
      />
      <Route
        path="/logout"
        element={
          <OidcSecure>
            <LogOut />
          </OidcSecure>
        }
      />
      <Route
        path="/tenant/EditSettings/:tenantId"
        element={
          <OidcSecure>
            <EditSettings />
          </OidcSecure>
        }
      />
      <Route
        path="/honeywell/user/edit"
        element={
          <OidcSecure>
            <EditHoneywellUser />
          </OidcSecure>
        }
      />
      <Route
        path="/:role/user/info"
        element={
          <OidcSecure>
            <UserInformationPage />
          </OidcSecure>
        }
      />
      <Route
        path="/error"
        element={
          <OidcSecure>
            <ErrorPage />
          </OidcSecure>
        }
      />
      <Route path="/" element={<LoggedIn />} />
    </Routes>
  );
};